export default __webpack_public_path__ + "static/media/referral-share@3x.90e68b29.png";